import { Layout } from "~landing/components/layout";
import { Terms } from "~landing/components/terms/terms";

export function TermsOfService() {
	return (
		<Layout>
			<main>
				<Terms />
			</main>
		</Layout>
	);
}
